import SearchInputWrapper from './SearchInputWrapper';
import { SearchInput, StyledSearchIcon } from './styles';

export { SearchInput, StyledSearchIcon };

export default SearchInputWrapper;
